import { createFileRoute } from '@tanstack/react-router';

import { InviteUserScreen } from '@/features/users/components/workspace/InviteUserScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/users/invite')({
  beforeLoad: () => {
    requirePermission('user:invite');
  },
  component: InviteUserScreen,
  staticData: { crumb: 'Invite' },
});
